module.exports = __webpack_public_path__ + "img/sld_mfm_inv_2_t1_b1_dark.52faed3b.svg";